export default __webpack_public_path__ + "static/media/melbourne-city-at-night.df01cff2.png";